import { createSelector, createSlice } from '@reduxjs/toolkit';

const uislice = createSlice({
    name: 'uislice',
    initialState: {
        isNavigationItemHover: false,
    },
    reducers: {
        setNavigationItemHover: (state, action) => {
            state.isNavigationItemHover = action.payload;
        },
    },
});

export const selectIsNavigationItemHover = createSelector(
    [state => state.ui],
    isNavigationItemHover => isNavigationItemHover,
);

export const { setNavigationItemHover } = uislice.actions;

export default uislice.reducer;
